import OffreCommandeController from './offre.commande.controller';

export default {
    template: require('./offre.commande.tpl.html'),
    controller: OffreCommandeController
};
